<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="unit_of_measure.id && unit_of_measure.id > 0" @invoke-method="dbGetUnitOfMeasure(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="unit_of_measure.id && unit_of_measure.id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('units_of_measure.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in unit_of_measure_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != unit_of_measure.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('units_of_measure.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_unit_of_measure.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'units_of_measure' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="unit_of_measure.status" class="ribbon ribbon-top-right" :class="`ribbon-${unit_of_measure.status_class}`">
                            <span class="ribbon-span">{{ unit_of_measure.status }}</span>
                        </div>
                        <v-form ref="formUnitOfMeasure">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="unit_of_measure_dialog"
                                    v-model="unit_of_measure.id"
                                    :label="$t('lang.id')"
                                    :counter="showCounter(unit_of_measure.id, 'units_of_measure.id')"
                                    :rules="ifValid('units_of_measure.id')"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="unit_of_measure.unit"
                                    :label="`${$t('lang.unit')} *`"
                                    :counter="showCounter(unit_of_measure.unit, 'units_of_measure.unit')"
                                    :rules="ifValid('units_of_measure.unit')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="unit_of_measure.unit_abbrev"
                                    :label="`${$t('lang.unit_abbrev')} *`"
                                    :counter="showCounter(unit_of_measure.unit_abbrev, 'units_of_measure.unit_abbrev')"
                                    :rules="ifValid('units_of_measure.unit_abbrev')"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'units_of_measure' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveUnitsOfMeasure">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_unit_of_measure"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_unit_of_measure')"
                :message="$t('lang.delete_unit_of_measure_confirm')"
                @onConfirm="deleteUnitsOfMeasure()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_unit_of_measure_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteUnitOfMeasureDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            unit_of_measure: {},
            file_name: "",
            dbGetUnitOfMeasure: _.debounce(this.getUnitOfMeasure, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchUnitOfMeasure", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.unit_of_measure) {
                        this.unit_of_measure = this.assignObj2(data.unit_of_measure, this.rules_units_of_measure);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=unit_of_measure_status&sort_by=2",
                            method: "get",
                            stateProperty: "unit_of_measure_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "units_of_measure", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchUnitOfMeasure", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.unit_of_measure) {
                        next((vm) => {
                            vm.unit_of_measure = vm.assignObj2(data.unit_of_measure, vm.rules_units_of_measure);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=unit_of_measure_status&sort_by=2",
                                method: "get",
                                stateProperty: "unit_of_measure_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "units_of_measure", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=unit_of_measure_status&sort_by=2",
            method: "get",
            stateProperty: "unit_of_measure_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_units_of_measure: (state) => state.units_of_measure.rules_units_of_measure,
            unit_of_measure_status_options: (state) => state.settings.unit_of_measure_status_options,
            units_of_measure: (state) => state.units_of_measure.units_of_measure,
            selectedUnitOfMeasure: (state) => state.units_of_measure.selectedUnitOfMeasure,
        }),
    },
    methods: {
        ...mapActions(["fetchUnitOfMeasure", "saveUnitOfMeasure", "deleteUnitOfMeasure", "printUnitOfMeasure"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getUnitOfMeasure(pg_refresh = false) {
            this.startLoader();

            this.fetchUnitOfMeasure({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.unit_of_measure) {
                    this.unit_of_measure = this.assignObj2(data.unit_of_measure, this.rules_units_of_measure);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printUnitOfMeasure({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.unit_of_measure) {
                    if (this.dev_mode) {
                        this.file_name = data.unit_of_measure.file_name;
                    } else {
                        this.$refs.print.printReport(data.unit_of_measure.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveUnitsOfMeasure() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formUnitOfMeasure")) {
                    let body = this.prepForm(this.unit_of_measure, this.rules_units_of_measure);

                    this.saveUnitOfMeasure({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.unit_of_measure) {
                            this.$router.push({ name: "unit_of_measure", params: { id: data.unit_of_measure.id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveUnitsOfMeasure({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.unit_of_measure) {
                    this.unit_of_measure = this.assignObj2(data.unit_of_measure, this.rules_units_of_measure);
                }
            });
        },
        deleteUnitsOfMeasure() {
            this.deleteUnitOfMeasure({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "units_of_measure" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchUnitOfMeasure({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.unit_of_measure) {
                        this.unit_of_measure = this.assignObj2(data.unit_of_measure, this.rules_units_of_measure);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    created() {},
};
</script>
